import React from 'react';

const UpdateProductionPage = () => {
  return <div>Page pour mettre à jour une production</div>;
};

export default UpdateProductionPage;
